export default __webpack_public_path__ + "static/media/LoadingDrSaude.fea46d23.png";